// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"136":"af2c8a81eb56ca204aba","304":"2952d245e7146b6692ec","360":"bfc9b5d5e68722d32945","552":"d1aa03f65fd98a56c2ed"}[chunkId] + ".js";
};